import React from 'react';
import MetaData from '@minecraft.meta-data';

const Meta = () => <MetaData title="Casting Networks" />;

export default Meta;
